import React from 'react';
import Icon from '../../Icon/Icon';
import Link from '../../Link/Link';
import styles from './KpisLegend.module.sass';

const KpisLegend = props => {
  const {
    data
  } = props;
  const kpisChildren = (data || []).map(({
    name,
    value,
    icon,
    link
  }, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles['kpi']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['kpi-content']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['icon-container']
    }, /*#__PURE__*/React.createElement(Icon, {
      name: icon
    })), /*#__PURE__*/React.createElement("div", {
      className: styles['value-container']
    }, link && link.to ? /*#__PURE__*/React.createElement(Link, {
      className: styles['label'],
      to: link.to,
      label: name
    }) : /*#__PURE__*/React.createElement("small", {
      className: styles['label']
    }, name), /*#__PURE__*/React.createElement("h3", {
      className: styles['value']
    }, value))));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles['legend']
  }, kpisChildren);
};

export default KpisLegend;